var _ellipse, _rect, _rect2, _path, _circle, _path2, _path3, _path4, _circle2, _circle3, _path5, _path6, _path7, _rect3, _path8, _path9, _path10, _path11, _path12, _circle4, _circle5, _path13, _path14, _path15, _path16, _polygon, _path17, _path18, _circle6, _path19, _polygon2, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _circle7, _polygon3, _path31, _path32, _path33;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeowner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 906,
    height: 510.5,
    viewBox: "0 0 906 510.5",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 834.77953,
    cy: 505.5,
    rx: 24,
    ry: 4,
    fill: "#f2f2f2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 860.77953,
    y: 123.5,
    width: 2,
    height: 42,
    fill: "#f2f2f2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 828.77953,
    y: 96.5,
    width: 12,
    height: 414,
    fill: "#f2f2f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1036.71727,323.75H926.84178a8.49964,8.49964,0,0,1-8.43432-9.5542l14-112a8.51359,8.51359,0,0,1,8.43432-7.4458h81.87549a8.5136,8.5136,0,0,1,8.43433,7.4458l14,112a8.49964,8.49964,0,0,1-8.43433,9.5542Z",
    transform: "translate(-147 -194.75)",
    fill: "#f2f2f2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 861.77953,
    cy: 165.5,
    r: 7,
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272.56021,594.1142c-5.05211,17.52641-19.80363,29.79509-35.19135,40.21717q-3.2228,2.18325-6.44766,4.266c-.01456.00637-.02957.02-.04432.0265-.10343.06644-.20707.133-.30344.1999-.44371.286-.88759.57223-1.32762.855l.24171.10859s.23735.1262-.02233.02023c-.07728-.03233-.15825-.06136-.23537-.09387-8.93929-3.60536-18.03735-7.4764-24.888-14.23042-7.1065-7.0136-11.25952-18.01412-7.41141-27.228a17.59159,17.59159,0,0,1,1.90481-3.41887c.31214-.44666.64831-.87415.99832-1.29373a18.85593,18.85593,0,0,1,32.38561,5.72979c1.13049-10.52575-7.5488-19.34264-15.90135-25.84822-8.35624-6.50227-17.85126-13.5834-19.46674-24.05073-.90216-5.82389,1.12305-11.46779,4.81223-15.99852.11421-.13767.22827-.27514.34591-.409a27.51847,27.51847,0,0,1,17.68718-9.48884c12.8132-1.33168,25.25926,5.45059,34.56778,14.35941C269.2462,552.17026,278.30348,574.18677,272.56021,594.1142Z",
    transform: "translate(-147 -194.75)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M248.476,571.18985a46.77918,46.77918,0,0,1,5.60443,12.36093,40.61956,40.61956,0,0,1,1.404,11.99679,52.0438,52.0438,0,0,1-6.81624,23.68462,74.90268,74.90268,0,0,1-11.29937,15.09918q-3.2228,2.18325-6.44766,4.266c-.01456.00637-.02957.02-.04432.0265-.10343.06644-.20707.133-.30344.1999-.44371.286-.88759.57223-1.32762.855,0,0,.47906.23479.21938.12882-.07728-.03233-.15825-.06136-.23537-.09387a41.40489,41.40489,0,0,0-13.249-35.6508,41.75957,41.75957,0,0,0-17.14558-9.22645c.31214-.44666.64831-.87415.99832-1.29373a43.29512,43.29512,0,0,1,7.14664,2.70437A42.42394,42.42394,0,0,1,226.162,614.74056a43.37384,43.37384,0,0,1,4.72253,23.80133c.36729-.33284.735-.6729,1.09168-1.00976,6.79289-6.33308,12.82633-13.60244,16.90957-21.99188a48.41641,48.41641,0,0,0,5.06985-22.90745c-.33324-8.6533-3.781-16.66847-8.77294-23.64614a101.34581,101.34581,0,0,0-19.2105-19.79843A115.15779,115.15779,0,0,0,202.08,534.43767a.828.828,0,0,1-.41667-1.06262.70423.70423,0,0,1,.34591-.409.613.613,0,0,1,.53242.02262c1.0539.48517,2.10048.977,3.13868,1.49006a116.46519,116.46519,0,0,1,24.06247,15.87266C236.8256,556.38989,243.49365,563.2889,248.476,571.18985Z",
    transform: "translate(-147 -194.75)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.62527,638.25h55.36362a4.28276,4.28276,0,0,1,4.24985,4.81413l-7.05426,56.43411a4.2898,4.2898,0,0,1-4.24986,3.75176H206.67953a4.28978,4.28978,0,0,1-4.24985-3.75176l-7.05427-56.43411a4.28276,4.28276,0,0,1,4.24986-4.81413Z",
    transform: "translate(-147 -194.75)",
    fill: "#f2f2f2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.13798,
    cy: 502.00509,
    r: 6.92872,
    fill: "#ccc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 670.80193,
    cy: 502.00509,
    r: 6.92872,
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M507.16446,600.33045H398.61456a19.07553,19.07553,0,0,1-19.054-19.054V507.37016a19.07553,19.07553,0,0,1,19.054-19.054h108.5499a19.07553,19.07553,0,0,1,19.054,19.054v73.90632A19.07553,19.07553,0,0,1,507.16446,600.33045Z",
    transform: "translate(-147 -194.75)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M653.2449,600.90784H544.695a19.07553,19.07553,0,0,1-19.054-19.054V507.94756a19.07553,19.07553,0,0,1,19.054-19.054H653.2449a19.07553,19.07553,0,0,1,19.054,19.054v73.90631A19.07553,19.07553,0,0,1,653.2449,600.90784Z",
    transform: "translate(-147 -194.75)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M799.32535,601.48523H690.77545a19.07553,19.07553,0,0,1-19.054-19.054V508.525a19.07553,19.07553,0,0,1,19.054-19.054h108.5499a19.07553,19.07553,0,0,1,19.054,19.054v73.90631A19.07553,19.07553,0,0,1,799.32535,601.48523Z",
    transform: "translate(-147 -194.75)",
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 215.81619,
    y: 401.5387,
    width: 478.08147,
    height: 99.889,
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M380.138,696.75509H359.35183c-10.50641,0-19.054-9.705-19.054-21.6342V570.8834H380.138Z",
    transform: "translate(-147 -194.75)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M838.58808,696.75509H817.80193V554.7164h39.84012V672.34219C857.64205,685.80353,849.09449,696.75509,838.58808,696.75509Z",
    transform: "translate(-147 -194.75)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M526.79582,617.07485H380.138V585.89562q73.32919-42.06328,146.65784,0Z",
    transform: "translate(-147 -194.75)",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M672.87627,617.65224H526.21843V586.473q73.32919-42.06327,146.65784,0Z",
    transform: "translate(-147 -194.75)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M818.95672,618.22963H672.29888V587.05041q73.3292-42.06328,146.65784,0Z",
    transform: "translate(-147 -194.75)",
    fill: "#ccc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.84572,
    cy: 368.62729,
    r: 34.06619,
    fill: "#ccc"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 703.71334,
    cy: 367.47251,
    r: 34.06619,
    fill: "#ccc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M750.36376,495.48413a10.52663,10.52663,0,0,1,.10713,1.654l40.83394,28.14389,10.88943-5.1551,9.92791,15.41722-18.39069,10.99952a8,8,0,0,1-9.5486-1.002l-41.35443-38.38235a10.4971,10.4971,0,1,1,7.53531-11.67516Z",
    transform: "translate(-147 -194.75)",
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M792.09163,522.86016a4.49518,4.49518,0,0,1,2.4465-2.83816l20.5327-9.408a12.49742,12.49742,0,0,1,13.69556,20.90858L811.792,546.53208a4.5,4.5,0,0,1-6.75219-.91657l-12.39752-19.04843A4.495,4.495,0,0,1,792.09163,522.86016Z",
    transform: "translate(-147 -194.75)",
    fill: "#1a5255"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M749.8491,497.31856l-.20515.01484-.56042-7.74517c-.17913-2.47572-1.78059-4.37732-3.57694-4.24735l0,0-11.90631.86151c-1.79636.13-5.10216,2.38665-4.923,4.86237l.14434,1.9948,2.93018,40.49581c.17914,2.47572,3.77538,4.233,5.57173,4.103h0l11.90632-.86152c1.79635-.13,3.10737-2.24231,2.92824-4.718v0l-2.11518-29.23228.20514-.01484Z",
    transform: "translate(-147 -194.75)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M748.39349,489.6696l3.07,42.42808c.13377,1.84892-.84532,3.42644-2.18687,3.52355l-11.96344.86564c-1.34155.097-2.53754-1.3231-2.67135-3.172l-3.07-42.42808c-.13376-1.84892.84533-3.42644,2.18688-3.52355l1.45131-.105a1.84749,1.84749,0,0,0,.78429,2.02782.88852.88852,0,0,0,.44286.08594l6.821-.49355c.63763-.0468,1.1026-.79715,1.03854-1.676a2.13193,2.13193,0,0,0-.12848-.59245l1.55392-.11243C747.0637,486.40055,748.25969,487.82069,748.39349,489.6696Z",
    transform: "translate(-147 -194.75)",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "433.561 392.89 429.615 381.283 472.509 360.539 478.333 377.671 433.561 392.89",
    fill: "#ffb8b8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M570.31592,594.42579l-12.72313-37.42705.47339-.16095a15.38605,15.38605,0,0,1,19.52009,9.61488l.00032.00092,7.77074,22.8591Z",
    transform: "translate(-147 -194.75)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M750.8026,595.92416a52.352,52.352,0,0,1-26.59248-5.56753L673.77144,556.0435l-58.89509,21.80873a6.52023,6.52023,0,0,1-8.11284-3.652l-2.88654-6.94309a6.46712,6.46712,0,0,1,3.33919-8.42458l56.267-25.26822a32.88554,32.88554,0,0,1,21.50752-1.86025l78.1124,19.90533,20.64717,24.52014-.22949.31622C773.38514,590.43,761.36215,595.1601,750.8026,595.92416Z",
    transform: "translate(-147 -194.75)",
    fill: "#2f2e41"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 667.59709,
    cy: 274.15238,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M789.38494,587.062l-39.52931-29.41727L776.814,538.48518c-.77119-2.48158-4.19175-16.66967,14.51625-26.34092,5.92149-3.06082,10.188-5.69591,12.68079-7.83109a19.1416,19.1416,0,0,1,12.73791-4.64673,18.974,18.974,0,0,1,17.831,24.5604c-3.901,12.68032-10.11471,29.48263-17.565,37.51831a232.61337,232.61337,0,0,1-27.33117,25.09258Z",
    transform: "translate(-147 -194.75)",
    fill: "#1a5255"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "439.829 403.176 435.883 391.568 478.777 370.825 484.601 387.956 439.829 403.176",
    fill: "#ffb8b8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M576.5838,604.71131l-12.72312-37.427.47339-.16095a15.38606,15.38606,0,0,1,19.52009,9.61487l.00031.00093,7.77074,22.8591Z",
    transform: "translate(-147 -194.75)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M757.07049,606.20969a52.35209,52.35209,0,0,1-26.59248-5.56753L680.03933,566.329l-58.89509,21.80874a6.52026,6.52026,0,0,1-8.11285-3.65206l-2.88653-6.94308a6.46711,6.46711,0,0,1,3.33919-8.42458l56.267-25.26822a32.88547,32.88547,0,0,1,21.50752-1.86025L769.371,561.8949,790.01813,586.415l-.22949.31621C779.653,600.7155,767.63,605.44562,757.07049,606.20969Z",
    transform: "translate(-147 -194.75)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M745.73344,524.94715a10.527,10.527,0,0,1,.805,1.44889l48.95175,7.95077,7.6337-9.321,15.57282,9.682-11.91036,17.81433a8,8,0,0,1-9.05817,3.18268l-53.80572-16.98049a10.4971,10.4971,0,1,1,1.811-13.77718Z",
    transform: "translate(-147 -194.75)",
    fill: "#ffb8b8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M795.16429,531.82126a4.49517,4.49517,0,0,1,.99576-3.61233l14.52749-17.2932a12.49742,12.49742,0,0,1,21.3288,13.03148L823.1028,544.779a4.5,4.5,0,0,1-6.49444,2.06264L797.249,534.93547A4.49494,4.49494,0,0,1,795.16429,531.82126Z",
    transform: "translate(-147 -194.75)",
    fill: "#1a5255"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M808.03069,495.9518a53.614,53.614,0,0,0,11.276-32.06407,33.1019,33.1019,0,0,1-11.20613,5.41262c-4.29157,1.143-9.0096,1.3729-13.05121-.46813-5.68859-2.59126-9.05322-9.19992-8.4076-15.41747s4.94246-11.77179,10.53709-14.56013a24.858,24.858,0,0,1,18.26706-1.10575,21.71889,21.71889,0,0,1,23.33416-3.114c8.69367,4.267,13.5018,14.14816,14.33558,23.79658s-1.64493,19.24168-4.10249,28.609l-.27767,1.05838c-.7651,2.91631-2.98912,8.51158-2.98912,8.51158s-12.916-2.54892-18.04727-4.18286C820.2615,495.11567,808.03069,495.9518,808.03069,495.9518Z",
    transform: "translate(-147 -194.75)",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M746.46278,498.30568l-10.52376.76148a1,1,0,0,1-.14434-1.99479l10.52376-.76147a1,1,0,1,1,.14434,1.99478Z",
    transform: "translate(-147 -194.75)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M746.82362,503.29265l-10.52375.76147a1,1,0,1,1-.14434-1.99478l10.52375-.76148a1,1,0,0,1,.14434,1.99479Z",
    transform: "translate(-147 -194.75)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M747.18447,508.27961l-10.52376.76147a1,1,0,0,1-.14434-1.99478l10.52376-.76148a1,1,0,0,1,.14434,1.99479Z",
    transform: "translate(-147 -194.75)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1052,705.25H148a1,1,0,0,1,0-2h904a1,1,0,0,1,0,2Z",
    transform: "translate(-147 -194.75)",
    fill: "#3f3d56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M627.77953,372.25h-101a9.01031,9.01031,0,0,1-9-9v-87a9.01031,9.01031,0,0,1,9-9h101a9.01032,9.01032,0,0,1,9,9v87A9.01032,9.01032,0,0,1,627.77953,372.25Zm-101-103a7.00786,7.00786,0,0,0-7,7v87a7.00786,7.00786,0,0,0,7,7h101a7.00787,7.00787,0,0,0,7-7v-87a7.00787,7.00787,0,0,0-7-7Z",
    transform: "translate(-147 -194.75)",
    fill: "#f2f2f2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M613.01256,358.75H541.5465a8.50958,8.50958,0,0,1-8.5-8.5v-61a8.50958,8.50958,0,0,1,8.5-8.5h71.46606a8.50958,8.50958,0,0,1,8.5,8.5v61A8.50958,8.50958,0,0,1,613.01256,358.75Z",
    transform: "translate(-147 -194.75)",
    fill: "#e6e6e6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.77953,
    cy: 54.5,
    r: 5,
    fill: "#f2f2f2"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "441.292 74.014 430.782 56.451 420.332 74.011 418.613 72.989 430.777 52.549 443.008 72.986 441.292 74.014",
    fill: "#f2f2f2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M589.27953,312.75a21.02288,21.02288,0,0,0-.49561-4.5H573.77953a4.00008,4.00008,0,0,0-4,4v21.42426A20.98569,20.98569,0,0,0,589.27953,312.75Z",
    transform: "translate(-147 -194.75)",
    fill: "#1a5255"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M568.27953,334.75a22,22,0,1,1,21.48132-26.71338l.26526,1.21338H573.77953a3.00335,3.00335,0,0,0-3,3v22.356l-1.103.07812C569.21361,334.71777,568.75072,334.75,568.27953,334.75Zm0-42a20,20,0,0,0,0,40c.16772,0,.33423-.00488.5-.0127V312.25a5.0058,5.0058,0,0,1,5-5h13.72156A20.11536,20.11536,0,0,0,568.27953,292.75Z",
    transform: "translate(-147 -194.75)",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M597.77953,341.25h-24a5.0058,5.0058,0,0,1-5-5v-3.50732l.92932-.06592A19.9444,19.9444,0,0,0,587.807,308.46387l-.26538-1.21387h10.23792a5.0058,5.0058,0,0,1,5,5v24A5.0058,5.0058,0,0,1,597.77953,341.25Zm-27-6.66406V336.25a3.00335,3.00335,0,0,0,3,3h24a3.00336,3.00336,0,0,0,3-3v-24a3.00336,3.00336,0,0,0-3-3H589.9923a21.81325,21.81325,0,0,1,.28723,3.5A22.06031,22.06031,0,0,1,570.77953,334.58594Z",
    transform: "translate(-147 -194.75)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeowner);
export default __webpack_public_path__ + "static/media/homeowner.40a87d3cecf9fcc71a6c38c6517d06ff.svg";
export { ForwardRef as ReactComponent };